import React, { useState, useEffect, useContext } from 'react';
import { Tab, TabProps, Dimmer, Loader, Button } from 'semantic-ui-react';

import SignUpComponent from '../../components/signUpComponent';
import LoginComponent from '../../components/loginComponent';
import * as Authentication from '../../../services/Authentication';
import * as Database from '../../../services/db';
import * as User from '../../../services/User';
import queryString from 'query-string';

import './style.less';
import ConnectedResident from '../../components/connectedResident';
import UserContext from '../../../contexts/UserContext';
import RedirectContext from '../../../contexts/RedirectContext';

const AlexaLinkingLogin = (props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [logInError, setLogInError] = useState<string>('');
    const [redirectUri,setRedirectUri] = useState<string>('');
    const [redirectState, setRedirectState] = useState('');
    const { userObject, setUser } = useContext(UserContext);
    const toggleRedirect = useContext(RedirectContext);

    useEffect(() => {
        const { redirect_uri,state } = queryString.parse(props.location.search);

        if (typeof(redirect_uri) === 'string' && typeof(state) === 'string') {
            setRedirectUri(redirect_uri)
            setRedirectState(state);
        }

    }, [props.location.search]);



    const handleLogout = async () => {
        try {
            await Authentication.cognitoSignOut();

            const signedOutUser = {
                authenticatedUser: undefined,
                profile: undefined,
                authenticated: false,
            };
            setUser(signedOutUser);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        userObject.authenticated && handleLogout();
    }, []);

    const handleLoginSubmit = async (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        username: string,
        password: string,
        newSignup: boolean = false,
    ): Promise<void> => {
        e.preventDefault();

        setLoading(true);

        try {
            const user = await Authentication.cognitoSignIn(username, password);
            console.log('username', user);
            const dbUserProfileResponse = await Database.getUserDbProfile();
            const userProfile = dbUserProfileResponse.userProfile;

            const connectedRegistrants = await Database.getRelatedRegistrants();

            const signedInUser = {
                cognitoUser: user,
                profile: userProfile,
                registrants: {
                    list: connectedRegistrants.residents,
                    activeRegistrantsIndexes:
                        connectedRegistrants.residents && connectedRegistrants.residents.length ? [0] : [],
                },
                username: user.username,
                authenticated: true,
            };

            if (!userProfile) throw Error('No user profile');
            setUser(signedInUser);

            toggleRedirect(`/link-resident-list?redirect_uri=${redirectUri}&state=${redirectState}`);
            return;
        } catch (error) {
            console.log(error.message);
            const userExists = await Authentication.checkIfUserExists(username);
            if (!userExists) {
                setLogInError('User does not exist');
            } else {
                setLogInError('Unable to log in.');
            }
            setLoading(false);
        }
    };



    return (
        <div className="login-wrapper">
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Speak 2 Family Logo" className="logo" />

            <LoginComponent
                handleLoginSubmit={handleLoginSubmit}
                error={logInError}
                locationState={props.location.state}
            />

            {/* <div className="signup-container">
                If you don't have an account
                <Button
                    className="signup-button"
                    href="https://www.speak2family.com/join"
                    role="link"
                    color="teal"
                    basic
                >
                    Sign Up
                </Button>
            </div> */}
            <h4 className="text-center">The app is available for download</h4>
            <div className="app-links">
                <a
                    href="https://play.google.com/store/apps/details?id=com.speak2software.family&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                    className="play-store"
                >
                    <img
                        alt="Get it on Google Play"
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    />
                </a>
                <a href="https://apps.apple.com/us/app/speak2-family/id1503580779" className="app-store">
                    <img src="/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" />
                </a>
            </div>
        </div>
    );
};

export default AlexaLinkingLogin;
